import React from 'react';
import { AlertTriangle, Clock, AlertCircle } from 'lucide-react';

const SLAAlertsPanel = ({ alerts = [], cardClasses = '' }) => {
  // Agrupar alertas por tipo
  const alertsByType = alerts.reduce((acc, alert) => {
    const tipo = alert.tipo_alerta || 'otros';
    if (!acc[tipo]) {
      acc[tipo] = [];
    }
    acc[tipo].push(alert);
    return acc;
  }, {});

  const getAlertConfig = (tipo) => {
    switch (tipo) {
      case 'sla_primera_respuesta':
        return {
          label: 'Primera Respuesta',
          icon: AlertTriangle,
          color: 'from-red-500 to-red-600',
          bgColor: 'bg-red-500/20',
          textColor: 'text-red-400',
          borderColor: 'border-red-500/50'
        };
      case 'sla_resolucion':
        return {
          label: 'Resolución',
          icon: AlertCircle,
          color: 'from-orange-500 to-orange-600',
          bgColor: 'bg-orange-500/20',
          textColor: 'text-orange-400',
          borderColor: 'border-orange-500/50'
        };
      case 'vencimiento_ticket':
        return {
          label: 'Vencimiento',
          icon: Clock,
          color: 'from-yellow-500 to-yellow-600',
          bgColor: 'bg-yellow-500/20',
          textColor: 'text-yellow-400',
          borderColor: 'border-yellow-500/50'
        };
      default:
        return {
          label: 'Otros',
          icon: AlertCircle,
          color: 'from-gray-500 to-gray-600',
          bgColor: 'bg-gray-500/20',
          textColor: 'text-gray-400',
          borderColor: 'border-gray-500/50'
        };
    }
  };

  const getUrgencyLevel = (tiempoRestante) => {
    if (tiempoRestante <= 1) return 'critical';
    if (tiempoRestante <= 4) return 'high';
    if (tiempoRestante <= 8) return 'medium';
    return 'low';
  };

  const getUrgencyColor = (level) => {
    switch (level) {
      case 'critical': return 'bg-red-500';
      case 'high': return 'bg-orange-500';
      case 'medium': return 'bg-yellow-500';
      case 'low': return 'bg-green-500';
      default: return 'bg-gray-500';
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
      {Object.entries(alertsByType).map(([tipo, alertas]) => {
        const config = getAlertConfig(tipo);
        const Icon = config.icon;
        const alertasUrgentes = alertas.filter(a => getUrgencyLevel(a.tiempo_restante_horas) === 'critical').length;

        return (
          <div key={tipo} className={`${cardClasses} p-6 rounded-xl border-2 ${config.borderColor}`}>
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center space-x-3">
                <div className={`p-3 rounded-lg bg-gradient-to-r ${config.color}`}>
                  <Icon className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-white">{config.label}</h3>
                  <p className="text-sm opacity-70">Alertas activas</p>
                </div>
              </div>
            </div>

            <div className="space-y-3">
              <div className="flex items-center justify-between">
                <span className="text-3xl font-bold text-white">{alertas.length}</span>
                {alertasUrgentes > 0 && (
                  <span className="px-3 py-1 bg-red-500/30 text-red-300 rounded-full text-sm font-semibold animate-pulse">
                    {alertasUrgentes} urgente{alertasUrgentes > 1 ? 's' : ''}
                  </span>
                )}
              </div>

              {/* Mostrar las 3 más urgentes */}
              <div className="space-y-2 mt-4">
                {alertas
                  .sort((a, b) => a.tiempo_restante_horas - b.tiempo_restante_horas)
                  .slice(0, 3)
                  .map((alerta, idx) => {
                    const urgency = getUrgencyLevel(alerta.tiempo_restante_horas);
                    return (
                      <div key={idx} className="flex items-center space-x-2 text-sm">
                        <div className={`w-2 h-2 rounded-full ${getUrgencyColor(urgency)}`}></div>
                        <span className="opacity-70">Ticket #{alerta.ticket_id}</span>
                        <span className={config.textColor}>
                          {alerta.tiempo_restante_horas.toFixed(1)}h
                        </span>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SLAAlertsPanel;
